// @ts-nocheck
import { Button, Dialog, DialogActions, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../styles/ButtonTextStyle';

interface DeleteEntityModalProps {
  isOpen: boolean;
  containsCards: boolean;
  onDelete?: () => void;
  onClose: () => void;
  headerTitle: string;
}

const DeleteEntityDialog: React.FC<DeleteEntityModalProps> = ({
  isOpen,
  containsCards,
  onDelete,
  onClose,
  headerTitle,
}) => {
  function handleDelete() {
    onDelete();
    onClose();
  }

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={onClose}
        maxWidth="md"
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '452px',
            },
          },
        }}
      >
        <div style={{ position: 'relative' }}>
          {containsCards && (
            <img
              src="../../../Content/icons/wizard/attention.svg"
              style={{ margin: '21px auto', display: 'block' }}
            />
          )}
          <DialogTitle sx={{ textAlign: containsCards ? 'center' : 'left', pr: '48px' }}>
            {headerTitle}
          </DialogTitle>
          <IconButton
            onClick={onClose}
            size="small"
            aria-label="close"
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
        <ThemeProvider theme={theme}>
          <DialogActions sx={{ gap: 1 }}>
            {containsCards ? (
              <Button onClick={onClose} color="info" variant="contained">
                OK
              </Button>
            ) : (
              <>
                <Button onClick={handleDelete} color="error" variant="contained">
                  Delete
                </Button>
                <Button onClick={onClose} color="inherit" variant="outlined">
                  Cancel
                </Button>
              </>
            )}
          </DialogActions>
        </ThemeProvider>
      </Dialog>
    </>
  );
};

export default DeleteEntityDialog;
